import Vue from "vue";
import apiClient, { fileClient } from "./Environment";
import * as Utils from "@/utils.js";

export default {
  getSpecialRatesTableData(data) {
    const payload = {
      startDate: Vue.moment().format("YYYY-MM-DD"),
      page: 0,
      columnsPerPage: 14
    };
    Object.assign(payload, data);
    return apiClient.get("/get-special-rates-table", { params: payload });
  },
  getSpecialRatesGroups(params) {
    return apiClient.get(
      "/get-special-rates-groups" + Utils.buildGetParams(params)
    );
  },
  postSpecialRatesChanges(data) {
    return apiClient.post("/set-special-rates-changes", data);
  },
  async downloadSpecialRates(data) {
    const response = await fileClient.post("/get-special-rates-csv", {
      hotel_id: data.hotel_id,
      year: data.year
    });
    return response.data;
  }
};
